import EpicGamesNav from 'epic-games-nav/app/scripts/EpicGamesNav';
import Immutable from 'seamless-immutable';
import PropTypes from 'prop-types';
import React from 'react';
import {generateRoutePath} from '@epic-core/common';
import {localizedMessage} from '../message/Message'
import root from 'window-or-global';
import {withRouter} from 'react-router';

class EpicGamesNavWrapper extends React.PureComponent {
    static propTypes = {
        history: PropTypes.object,
        location: PropTypes.object,
        localizationStore: PropTypes.object,
        loginStore: PropTypes.object,
        headerStore: PropTypes.object,
        appConfigStore: PropTypes.object,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool
    };

    /**
     * Checks the CMS 'useCustomCallback' and assigns an onClick pointing to the link's href
     * @param {Object} link
     */
    addOnClick(link, history, external) {
        if (link && link.useCustomCallback && link.href) {
            link.onClick = (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (external) {
                    root.location.href = link.href;
                } else {
                    history.push(generateRoutePath(link.href));
                }
            };
        }
        return Immutable(link);
    }

    /**
     * Prepares the array of site nav links for the header
     * @param {array} links
     */
    setLinks(links) {
        const {history} = this.props;
        links.forEach((link) => {
            let external = true;
            const linkPath = generateRoutePath(link.href);
            if (link.href && (linkPath === this.props.location.pathname ||this.props.location.pathname.indexOf(`${linkPath}/`) > -1)) {
                external = false;
                link.active = true;
            } else {
                link.active = false;
            }
            this.addOnClick(link, history, external);
            // We must go deeper!
            if (link.kids) {
                link.kids.recursive = true;
                this.setLinks(link.kids);
            }
        });
        return Immutable(links);
    }

    setCTA(callToAction) {
        const {localizationStore, history} = this.props;
        // Hide CTA if mobile & download
        const title = localizationStore.message('epic.common.download') || callToAction.title;
        const href = generateRoutePath('download', false);
        const onClick = (e) => {
            e.preventDefault();
            history.push(href);
        };
        return Immutable({title, href, onClick});
    }

    setAccountLinks(accountLinks) {
        if (accountLinks && accountLinks.signInLinks) {
            accountLinks.signInLinks[0].onClick = (e) => {
                this.signIn(e);
            };
            accountLinks.signOutLink.onClick = (e) => {
                this.signOut(e);
            };
        }
        return Immutable(accountLinks);
    }

    signIn(e) {
        e.preventDefault();
        const {baseUrl} = this.props.appConfigStore;
        root.location = `${baseUrl}/login?&state=${root.document.URL}`;
    }

    signOut(e) {
        e.preventDefault();
        const {baseUrl} = this.props.appConfigStore;
        root.location = `${baseUrl}/logout?&state=${root.document.URL}`;
    }

    register(e) {
        e.preventDefault();
        const {baseUrl} = this.props.appConfigStore;
        root.location = `${baseUrl}/register?isFromCTA=true&state=${baseUrl}/register-success`;
    }

    /**
     * Prepares an Immutable array of locale options for the header. Supports new LocalizationContext prop
     * and old LocalizationStore prop
     * @returns [{ name: 'English', lang: 'en-US'}]
     */
    getLocaleOptions = () => {
        const {supportedLocales} = this.props.localizationStore;
        const localeOptions = [];
        if (supportedLocales && supportedLocales.length) {
            for (let i = 0; i < supportedLocales.length; i++) {
                localeOptions.push({
                    name: localizedMessage(supportedLocales[i].name),
                    lang: supportedLocales[i].lang
                });
            }
        }

        return Immutable(localeOptions);
    }

    render() {
        const config = this.props.headerStore.config ? this.props.headerStore.config.asMutable({deep: true}) : {};
        const {isLoggedIn} = this.props.loginStore;
        const links = this.setLinks(config.links || []);
        const accountLinks = this.setAccountLinks(config.accountLinks || {});
        const accountInfo = this.props.loginStore.accountInfo || {};
        const displayName = accountInfo.displayName || '';
        const {locale} = this.props.localizationStore;
        const localeOptions = this.getLocaleOptions();
        const logoLink = this.addOnClick(config.logoLink || {}, this.props.history);
        const callToAction = this.setCTA(config.callToAction || {});
        const properties = Immutable(config.properties || []);

        const appConfigStore = this.props.appConfigStore || {};

        return (
            <div>
                <EpicGamesNav
                    epicPropertyName={config.epicPropertyName || ''}
                    epicPropertyClasses="transparent"
                    hideSearch={config.hideSearch}
                    hideSignIn={config.hideSignIn}
                    hideLocale={config.hideLocale}
                    hideShieldDownload={config.hideShieldDownload}
                    isLoggedIn={isLoggedIn || false}
                    displayName={displayName}
                    logoLink={logoLink}
                    links={links}
                    localeOptions={localeOptions}
                    locale={locale}
                    accountLinks={accountLinks}
                    euCookie={appConfigStore.euCookieMessage}
                    isEu={appConfigStore.euCookieEnabled && config.isEu}
                    callToAction={callToAction}
                    downloadLink={config.downloadLink}
                    messages={config.messages}
                    macDownloadUrl={config.macDownloadUrl}
                    pcDownloadUrl={config.pcDownloadUrl}
                    alert={config.alert}
                    properties={properties} />
            </div>
        );
    }
}

export default withRouter(EpicGamesNavWrapper);
